import { AuthGuard } from '../auth/AuthGuard';
import { ClientTiersProvider, useClientTiers } from '../auth/ClientTiersProvider';
import { AccountContextProvider } from '../auth/AccountContextProvider';
import { NoAccess } from '../pages/NoAccess';
import { ClientLayout } from './ClientLayout';

/**
 * #19758 — an account that is not a client-portal user gets Access denied IN PLACE OF the shell
 * (no nav, no pages, no /child-accounts round trip). Everyone else gets the shell exactly as
 * before — including while /client-it/me is loading and after a transient failure.
 */
function ShellOrNoAccess() {
  const { noAccess } = useClientTiers();
  if (noAccess) return <NoAccess />;
  return (
    // #16306 — mounts INSIDE ClientTiersProvider: it consumes the caller's own
    // accountId from that context rather than adding a second /client-it/me hop.
    <AccountContextProvider>
      <ClientLayout />
    </AccountContextProvider>
  );
}

export function AuthLayout() {
  return (
    <AuthGuard>
      <ClientTiersProvider>
        <ShellOrNoAccess />
      </ClientTiersProvider>
    </AuthGuard>
  );
}
